/** A single word in the captions, to which a timestamp can be attached.
 *
 * This component renders a Vocable "inline" inside the Slate.js editor, showing the attached timestamp.
 **/

import * as React from "react";
import classnames from 'classnames';
import styles from './Vocable.module.css';
import {LineGroupContext, useTimeMatch} from "../../ui/CaptionEditor/ui/LineGroup";
import {useCallback, useContext} from "react";
import {isEmpty} from "../../utils";
import {useSelected} from "slate-react";


type Props = {
  children: any,
  attributes: any,
  time?: number,
  duration?: number,
  vocableId: string,

  onClick?: any
};


const timeFormat = Intl.NumberFormat('en-US', { maximumFractionDigits: 2 });


export const Vocable = (props: Props) => {
  const lineGroup = useContext(LineGroupContext);
  const effectiveTiming = lineGroup.effectiveWordTimingsById.get(props.vocableId);
  const effectiveTime = effectiveTiming?.relativeTime ?? props.time;
  const effectiveDuration = effectiveTiming?.relativeDuration ?? props.duration;
  const realTime = (!isEmpty(lineGroup.lineTime) && !(isEmpty(effectiveTime))) ? lineGroup.lineTime + effectiveTime : null;
  const explicitRealTime = (!isEmpty(lineGroup.lineTime) && !(isEmpty(props.time))) ? lineGroup.lineTime + props.time : null;

  const matchesTimestamp = useTimeMatch(realTime, effectiveDuration);

  const handleClick = useCallback(() => {
    props.onClick(props.vocableId)
  }, [props.vocableId, props.onClick])

  const isSelected = useSelected();

  const {attributes, children} = props;

  return <span
    {...attributes}
    className={classnames({
      [styles.vocable]: true,
      [styles.isFocused]: isSelected,
      [styles.matchesCurrentTime]: matchesTimestamp
    })}
    onDoubleClick={props.onClick ? handleClick : null}
  >
      {children}
    <span
      className={styles.timestamp}
      contentEditable={false}
    >
      {!isEmpty(explicitRealTime) ? timeFormat.format(explicitRealTime) : null}
    </span>
  </span>;
}
